import { useEffect, useState } from "react";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";

import EntityTable from "../components/EntityTable";
import AddVehicleModal from "../components/modals/AddVehicleModal";
import {
  fetch,
  remove,
  activate,
  deactivate,
} from "../store/actions/vehicles-actions";
import bookingsAPI from "../API/endpoints/bookings";

export default function ManageVehicles() {
  const [isAddVehicleModalOpen, setIsAddVehicleModalOpen] = useState();

  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();
  const vehicles = useSelector((state) => state.vehicles.items);

  useEffect(() => {
    dispatch(fetch());
  }, [dispatch]);

  const toggleAddVehicleModal = () => {
    setIsAddVehicleModalOpen((prev) => !prev);
  };

  const handleVehicleAdded = () => {
    messageApi.open({
      type: "success",
      content: "Vehicle has been added successfully",
    });
    toggleAddVehicleModal();
  };

  const checkIfVehicleHasBooking = async (id) => {
    const bookings = await bookingsAPI.get({ vehicle: id });
    const hasBookings = bookings.data.content.length;
    if (hasBookings) {
      throw new Error("This vehicle has bookings");
    }
  };

  const handleRemoveVehicle = async (id, toggleDeleteModal) => {
    try {
      await checkIfVehicleHasBooking(id);
      await dispatch(remove(id));
      toggleDeleteModal();
    } catch (error) {
      messageApi.open({
        type: "error",
        content:
          error.message ||
          error.response?.data?.detail ||
          "Error removing vehicle",
      });
    }
  };

  const handleChangeStatus = async (
    { id = null, active },
    toggleActivateModal
  ) => {
    try {
      active ? await dispatch(deactivate(id)) : await dispatch(activate(id));
      toggleActivateModal();
    } catch (error) {
      messageApi.open({
        type: "error",
        content:
          error.response?.data?.detail || "Error changing vehicle status",
      });
    }
  };

  const columns = [
    {
      title: "Plate Number",
      dataIndex: "licensePlate",
      key: "licensePlate",
    },
    {
      title: "Vehicle Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Technical Passport Number",
      dataIndex: "techNumber",
      key: "techNumber",
    },
  ];

  const data = vehicles.map((vehicle, index) => ({ ...vehicle, key: index }));

  return (
    <>
      {contextHolder}
      <EntityTable
        entity="vehicle"
        columns={columns}
        data={data}
        onAddRow={toggleAddVehicleModal}
        onDeleteRow={handleRemoveVehicle}
        onChangeStatus={handleChangeStatus}
      />
      <AddVehicleModal
        open={isAddVehicleModalOpen}
        onClose={toggleAddVehicleModal}
        onVehicleAdded={handleVehicleAdded}
      />
    </>
  );
}
